import React from "react";

import { useLocation, useNavigate } from "react-router-dom";

import { useUser } from "@components/user-context";
import { usePrettyLogEventPage } from "@components/v2/analytics";

import { Tab } from "./tab";

export const Tabs = () => {
  const { user } = useUser();
  const location = useLocation();
  const navigate = useNavigate();
  const prettyLogEventPage = usePrettyLogEventPage();

  return (
    <div className="flex gap-1 text-sm relative">
      <Tab
        active={location.pathname.includes("breakdowns")}
        onClick={() => {
          prettyLogEventPage({
            domain: "Breakdown v2",
            action: "onClick",
            additionalActionInfo: "Change tab to ManageBreakdowns",
          });

          navigate(user.pathFromRoot("/breakdowns"));
        }}
      >
        Manage breakdowns
      </Tab>
      <Tab
        active={location.pathname.includes("label-assignment")}
        onClick={() => {
          prettyLogEventPage({
            domain: "Breakdown v2",
            action: "onClick",
            additionalActionInfo: "Change tab to LabelsAssignment",
          });

          navigate(user.pathFromRoot("/label-assignment"));
        }}
      >
        Label assignment
      </Tab>
    </div>
  );
};
